import React from "react";
import { footerLinks } from "../CertificateVerification/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Footer25 = () => {
  const width = window.innerWidth;
  return (
    <div
      className="z-50 mx-auto mt-11 -ml-[12px] flex w-full w-[calc(100%+24px)] flex-col items-start justify-center bg-[#0B1D2B] p-4 py-6  md:mt-[90px] md:-ml-0 md:w-full md:items-center md:px-0 md:pt-8 md:pb-6"
      style={{
        filter: "drop-shadow(0px -4px 10px rgba(0, 0, 0, 0.2))",
      }}
    >
      {width < 1280 ? (
        <div className="mx-auto flex w-full max-w-[768px] flex-col items-start justify-center">
          <div className="flex w-full items-center justify-start gap-2">
            <div className="flex w-fit items-center gap-2 rounded-md bg-white p-[6px]">
              <img
                src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
                loading="eager"
                alt=""
                width={24}
                height={24}
                className="h-6 w-6"
              />
              <p className="text-xs font-medium text-black">LearnTube.ai</p>
            </div>
            <div className="h-[32px] border-[1px] border-white/30" />
            <img
              alt=""
              className="-ml-[24px] h-full w-[160px]"
              src="https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png"
            />
          </div>
          <div className="justify- mt-4 flex w-full items-center">
            <div
              className={` ${
                window.innerWidth <= 360 ? "gap-[20px]" : "gap-[20px]"
              } flex w-full items-center justify-start `}
            >
              {footerLinks?.map((item, index) => (
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={item?.url}
                  className="flex h-[40px] w-[40px] items-center  justify-center rounded-full bg-[#406AFF] text-white md:h-[54px] md:w-[54px]"
                >
                  <FontAwesomeIcon
                    size="lg"
                    className="md:h-[24px] md:w-[24px]"
                    icon={item?.icon}
                  />
                </a>
              ))}
            </div>
          </div>
          <div className="mt-10 grid grid-cols-2 gap-2">
            <div className="flex flex-col items-start justify-start">
              <div className="text-[16px] font-semibold text-white/50">
                SUPPORT
              </div>
              <div className="mt-4 flex flex-col items-start justify-start gap-3">
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white"
                  onClick={() =>
                    window.open("https://learntube.ai/about-us", "_blank")
                  }
                >
                  About Us
                </div>
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white"
                  onClick={() =>
                    window.open(
                      "https://learntube.ai/termsandconditions",
                      "_blank",
                    )
                  }
                >
                  Terms & Conditions
                </div>
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white"
                  onClick={() =>
                    window.open("https://learntube.ai/privacypolicy", "_blank")
                  }
                >
                  Privacy Policy
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start justify-start">
              <div className="text-[16px] font-semibold text-white/50">
                CONTACT
              </div>
              <div className="mt-4 flex flex-col items-start justify-start gap-3">
                <a
                  className="flex cursor-pointer items-center gap-1 text-white"
                  href="mailto:hello@careerninja.in"
                >
                  <FontAwesomeIcon width={20} height={20} icon={faEnvelope} />
                  <span className="text-[14px] font-medium text-white">
                    {" "}
                    hello@careerninja.in
                  </span>
                </a>
                <a
                  href={"https://wa.me/919160950649"}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 text-white"
                >
                  <FontAwesomeIcon width={20} height={20} icon={faWhatsapp} />
                  <span className="text-[14px] font-medium text-white">
                    {" "}
                    +919160950649
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 w-full">
            <div className="text-[16px] font-semibold text-white/50">
              PRODUCTS
            </div>
            <div
              className="mt-4 flex w-full cursor-pointer flex-row items-center justify-between"
              onClick={() =>
                window.open("https://certified.learntube.ai", "_blank")
              }
            >
              <div className="text-[16px] font-semibold text-[#70AEFF]">
                Get Certified In Under 10 Minutes
              </div>
              <FontAwesomeIcon
                icon={faArrowRight}
                className="text-[16px] text-[#70AEFF]"
              />
            </div>

            <div
              className="mt-3 flex w-full cursor-pointer flex-row items-center justify-between"
              onClick={() =>
                window.open("https://personalise.learntube.ai", "_blank")
              }
            >
              <div className="text-[16px] font-semibold text-[#70AEFF]">
                Build A Personalised Course
              </div>
              <FontAwesomeIcon
                icon={faArrowRight}
                className="text-[16px] text-[#70AEFF]"
              />
            </div>

            <div
              className="mt-3 flex w-full cursor-pointer flex-row items-center justify-between"
              onClick={() =>
                window.open("https://resume.learntube.ai", "_blank")
              }
            >
              <div className="text-[16px] font-semibold text-[#70AEFF]">
                Build A Professional Resume
              </div>
              <FontAwesomeIcon
                icon={faArrowRight}
                className="text-[16px] text-[#70AEFF]"
              />
            </div>
          </div>

          <div
            className="mt-10 flex w-full cursor-pointer flex-row items-center justify-center gap-2"
            onClick={() =>
              window.open(
                "https://play.google.com/store/apps/details?id=com.learntube",
                "_blank",
              )
            }
          >
            <div className="text-[16px] font-semibold text-white/50">
              DOWNLOAD NOW!
            </div>
            <img
              alt=""
              src="https://storage.googleapis.com/learntube-web-assets/files/Optimized_LandingPagev3/google-play-badge__1__webp.png"
              className="h-[40px] w-[134px]"
            />
          </div>

          <div className="mt-6 flex w-full items-center justify-center gap-1">
            <p className="-mt-[2px] text-[12px] text-white/50">backed by</p>
            <div className="flex items-center gap-1">
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/use2460.svg?updatedAt=1728356838222"
                alt=""
                width={48}
                height={16}
                className="h-auto w-12"
              />
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/text3075.svg?updatedAt=1728356926579"
                alt=""
                width={76}
                height={16}
                className="w-19 h-auto"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="relative mx-auto flex w-full max-w-[1300px] flex-row items-start justify-start gap-[96px]">
          <div className="flex max-w-[380px] flex-col items-start justify-start">
            <div className="flex w-full items-center justify-start gap-2">
              <div className="flex w-fit flex-shrink-0 items-center gap-2 rounded-md bg-white p-[6px] md:rounded-[9px] md:p-[9px]">
                <img
                  src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
                  loading="eager"
                  alt=""
                  width={24}
                  height={24}
                  className="h-6 w-6 md:h-[30px] md:w-[30px]"
                />
                <p className="text-xs font-medium text-black md:text-[18px]">
                  LearnTube.ai
                </p>
              </div>
              <div className="h-[32px] border-[1px] border-white/30 md:h-[44px]" />
              <div className="-ml-[24px] h-full w-[160px] md:-ml-[36px] md:w-[280px]">
                <img
                  alt=""
                  className="h-full w-full object-cover"
                  src="https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png"
                />
              </div>
            </div>
            <div className=" mt-6 flex w-full items-center">
              <div
                className={` ${
                  window.innerWidth <= 360 ? "gap-[20px]" : "gap-[20px]"
                } flex w-full items-center justify-start `}
              >
                {footerLinks?.map((item, index) => (
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={item?.url}
                    className="flex h-[40px] w-[40px] items-center  justify-center rounded-full bg-[#406AFF] text-white md:h-[48px] md:w-[48px]"
                  >
                    <FontAwesomeIcon
                      size="lg"
                      className="md:h-[24px] md:h-[22px] md:w-[24px] md:w-[22px]"
                      icon={item?.icon}
                    />
                  </a>
                ))}
              </div>
            </div>
            <div
              className="mt-8 flex w-full cursor-pointer flex-row items-center justify-start gap-4"
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.learntube",
                  "_blank",
                )
              }
            >
              <div className="text-[16px] font-semibold text-white/50 md:text-[20px]">
                DOWNLOAD NOW!
              </div>
              <img
                alt=""
                src="https://storage.googleapis.com/learntube-web-assets/files/Optimized_LandingPagev3/google-play-badge__1__webp.png"
                className="h-[40px] w-[134px] md:h-[48px] md:w-[161px]"
              />
            </div>
          </div>
          <div className="flex flex-row items-start gap-[96px]">
            <div className="flex w-[150px] flex-col items-start justify-start">
              <div className="text-[16px] font-semibold text-white/50 md:text-[18px]">
                SUPPORT
              </div>
              <div className="mt-4 flex flex-col items-start justify-start gap-3">
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white md:text-[16px]"
                  onClick={() =>
                    window.open("https://learntube.ai/about-us", "_blank")
                  }
                >
                  About Us
                </div>
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white md:text-[16px]"
                  onClick={() =>
                    window.open(
                      "https://learntube.ai/terms-and-conditions",
                      "_blank",
                    )
                  }
                >
                  Terms & Conditions
                </div>
                <div
                  className="cursor-pointer text-[14px] font-semibold text-white md:text-[16px]"
                  onClick={() =>
                    window.open(
                      "https://learntube.ai/termsandconditions",
                      "_blank",
                    )
                  }
                >
                  Privacy Policy
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-start ">
              <div className="text-[16px] font-semibold text-white/50 md:text-[18px]">
                PRODUCTS
              </div>
              <div
                className="mt-4 flex w-full cursor-pointer flex-row items-center justify-start"
                onClick={() =>
                  window.open("https://certified.learntube.ai", "_blank")
                }
              >
                <div className="whitespace-nowrap text-[16px] font-semibold text-[#70AEFF] md:text-[16px]">
                  Get Certified In Under 10 Minutes
                </div>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="ml-1 text-[16px] text-[#70AEFF]"
                />
              </div>

              <div
                className="mt-3 flex w-full cursor-pointer flex-row items-center justify-start"
                onClick={() =>
                  window.open("https://personalise.learntube.ai", "_blank")
                }
              >
                <div className="whitespace-nowrap text-[16px] font-semibold text-[#70AEFF]">
                  Build A Personalised Course
                </div>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="ml-1 text-[16px] text-[#70AEFF]"
                />
              </div>

              <div
                className="mt-3 flex w-full cursor-pointer flex-row items-center justify-start"
                onClick={() =>
                  window.open("https://resume.learntube.ai", "_blank")
                }
              >
                <div className="whitespace-nowrap text-[16px] font-semibold text-[#70AEFF]">
                  Build A Professional Resume
                </div>
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="ml-1 text-[16px] text-[#70AEFF]"
                />
              </div>
            </div>
            <div className="flex flex-col items-start justify-start">
              <div className="text-[16px] font-semibold text-white/50 md:text-[18px]">
                CONTACT
              </div>
              <div className="mt-4 flex flex-col items-start justify-start gap-3">
                <a
                  className="flex cursor-pointer items-center gap-1 text-white"
                  href="mailto:hello@careerninja.in"
                >
                  <FontAwesomeIcon width={20} height={20} icon={faEnvelope} />
                  <span className="text-[14px] font-medium text-white md:text-[16px]">
                    {" "}
                    hello@careerninja.in
                  </span>
                </a>
                <a
                  href={"https://wa.me/919160950649"}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 text-white"
                >
                  <FontAwesomeIcon width={20} height={20} icon={faWhatsapp} />
                  <span className="text-[14px] font-medium text-white md:text-[16px]">
                    {" "}
                    +919160950649
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 right-0 flex items-center justify-center gap-1">
            <p className="-mt-[2px] text-[12px] text-white/50">backed by</p>
            <div className="flex items-center gap-1">
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/use2460.svg?updatedAt=1728356838222"
                alt=""
                width={48}
                height={16}
                className="h-auto w-12 md:w-20"
              />
              <img
                src="https://img.learntube.ai/public-assets/post-payment-updates/text3075.svg?updatedAt=1728356926579"
                alt=""
                width={76}
                height={16}
                className="w-19 h-auto md:w-28"
              />
            </div>
          </div>

          {/* <div className="mt-6 flex w-full items-center justify-center gap-2 text-[12px] font-medium text-white md:gap-3 md:text-[20px]">
        <div
          className="cursor-pointer"
          onClick={(e) => window.open("https://learntube.ai", "_blank")}
        >
          T&C
        </div>
        <div className="h-[6px] w-[6px] rounded-full bg-[#4285F4]/20" />
        <div
          className="cursor-pointer"
          onClick={(e) =>
            window.open("https://learntube.ai/about-us", "_blank")
          }
        >
          About Us
        </div>
        <div className="h-[6px] w-[6px] rounded-full bg-[#4285F4]/20" />
        <div
          className="cursor-pointer"
          onClick={(e) =>
            window.open("https://learntube.ai/contactus", "_blank")
          }
        >
          Privacy Policy
        </div>
      </div>
      <div className="mt-6 flex w-full flex-col items-center gap-2 rounded-lg bg-[#406AFF]/10 p-3">
        <div className="text-center text-[12px] text-white">
          <span className="mr-1 text-white/70">For Queries Contact:</span>
          <span className="font-semibold text-white ">Arjun Dhall</span>
        </div>

        <div className="mt-2 flex items-center justify-center gap-3"></div>
        <p className="hidden text-supertiny md:block md:text-xs ">
          © 2022 CareerNinja
        </p>
      </div> */}
        </div>
      )}
      <div className=" mt-6 flex w-full items-center justify-center gap-1 text-[12px] font-normal text-white/70 md:mt-10 md:text-[14px] ">
        <span className="text-[16px] text-white md:text-[14px]"> © </span> 2026
        LearnTube.ai
      </div>
    </div>
  );
};

export default Footer25;
